import { toBase64 } from '../../utils/toBase64';
import { ModalInfoTemplete } from '../Modal/ModalInfoTemplete';
import * as S from './ModalTankPhotos.styles';

interface IModalTankPhotos {
  isOpen: boolean;
  onClose: () => void;
  photo?: string | null;
  tankName: string;
}

export const ModalTankPhotos = ({
  isOpen,
  onClose,
  photo,
  tankName,
}: IModalTankPhotos) => {
  return (
    <ModalInfoTemplete
      isOpen={isOpen}
      closeModal={onClose}
      titleModal="Foto do tanque"
      option="tanque"
    >
      <S.Content>
        <div className="display">
          {!photo ? (
            <div className="empty">Nenhuma foto disponível.</div>
          ) : (
            <>
              <img src={toBase64(photo)} alt={tankName} />
              <div className="info">
                <strong>{tankName}</strong>
              </div>
            </>
          )}
        </div>
      </S.Content>
    </ModalInfoTemplete>
  );
};
